var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71577",
    "data-name": "Group 71577",
    transform: "translate(-2399 -17785)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12398",
    "data-name": "Ellipse 12398",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(2399 17785)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(2409.129 17795.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81674",
    "data-name": "Path 81674",
    d: "M39.771,20.518a2.28,2.28,0,0,1-1.938,2.288l-4.019.619a21.627,21.627,0,0,0-10.937,5.087l-2.925,2.566L11.59,21.666s1.095-1.032,1.292-1.247A21.735,21.735,0,0,0,18.355,8.693l.628-4.71a2.285,2.285,0,0,1,3.885-1.31L39.1,18.9a2.274,2.274,0,0,1,.673,1.615Z",
    transform: "translate(-0.714 -0.003)",
    fill: "#c4e04c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71566",
    "data-name": "Group 71566",
    transform: "translate(13.936 30.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71565",
    "data-name": "Group 71565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71564",
    "data-name": "Group 71564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81675",
    "data-name": "Path 81675",
    d: "M24.213,39.169l-4.038-4.846a.9.9,0,0,0-1.227-.144l-3.589,2.692a.9.9,0,0,0-.191,1.239l3.908,5.472a2.828,2.828,0,0,0,4.3.355l.662-.662a2.811,2.811,0,0,0,.829-2V40.98A2.833,2.833,0,0,0,24.213,39.169Z",
    transform: "translate(-15 -34.001)",
    fill: "#a30000"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_81676",
    "data-name": "Path 81676",
    d: "M32.081,8.9l-1.636,1.09c-.223.149,3.787,4.159,3.936,3.936l1.09-1.636A2.444,2.444,0,0,0,32.081,8.9Z",
    transform: "translate(-2.651 -0.67)",
    fill: "#c90d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81677",
    "data-name": "Path 81677",
    d: "M19.238,33.332l-4.719,4.2a4.444,4.444,0,0,1-2.97,1.13c-.09,0-.179,0-.269-.009a4.407,4.407,0,0,1-3.086-1.5L5.78,34.444a4.475,4.475,0,0,1,.377-6.325l4.719-4.2Z",
    transform: "translate(0 -2.257)",
    fill: "#c90d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81678",
    "data-name": "Path 81678",
    d: "M37.833,22.8l-4.019.619a21.627,21.627,0,0,0-10.937,5.087l-2.925,2.566L11.59,21.663s1.095-1.032,1.292-1.247A21.735,21.735,0,0,0,18.355,8.69l.628-4.71a2.27,2.27,0,0,1,3.885-1.31L39.1,18.9a2.282,2.282,0,0,1-1.265,3.9Z",
    transform: "translate(-0.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71569",
    "data-name": "Group 71569",
    transform: "translate(10.876 20.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71568",
    "data-name": "Group 71568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71567",
    "data-name": "Group 71567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81679",
    "data-name": "Path 81679",
    d: "M21.307,32l-.682.592-.673.592L11.59,23.777l.673-.6q.323-.323.619-.646Z",
    transform: "translate(-11.59 -22.53)",
    fill: "#a30000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71571",
    "data-name": "Group 71571",
    transform: "translate(33.674 1.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71570",
    "data-name": "Group 71570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81680",
    "data-name": "Path 81680",
    d: "M37.9,7.383a.9.9,0,0,1-.634-1.532l3.589-3.589A.9.9,0,0,1,42.12,3.531L38.531,7.12A.9.9,0,0,1,37.9,7.383Z",
    transform: "translate(-37 -2)",
    fill: "#c90d0d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71574",
    "data-name": "Group 71574",
    transform: "translate(34.571 10.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71573",
    "data-name": "Group 71573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71572",
    "data-name": "Group 71572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81681",
    "data-name": "Path 81681",
    d: "M41.589,12.794H38.9A.9.9,0,0,1,38.9,11h2.692a.9.9,0,1,1,0,1.794Z",
    transform: "translate(-38 -11)",
    fill: "#c90d0d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71576",
    "data-name": "Group 71576",
    transform: "translate(29.188 1.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71575",
    "data-name": "Group 71575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81682",
    "data-name": "Path 81682",
    d: "M32.9,6.486a.9.9,0,0,1-.9-.9V2.9a.9.9,0,1,1,1.794,0V5.589A.9.9,0,0,1,32.9,6.486Z",
    transform: "translate(-32 -2)",
    fill: "#c90d0d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcementIcon.fd500e833aafcc36888561393d181795.svg";
export { ForwardRef as ReactComponent };